export function EventXDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.EVENTX + '/:param0/:param')
        .setCustomActions({
            'getForAlerts': {
                method: 'GET',
                params: {param: '@sourceID', param0: 'forAlerts'}
            },
            'getIssueDetailsForAlert': {
                method: 'GET',
                path: '/impactIssueDetails'
            },
            'get': {
                method: 'GET',
                params: {param: '@sourceID', param0: ''}
            },
            'manualImpactAnalysis': {
              method: 'POST',
              path: XRAY_RESOURCE.EVENTX + '?adHoc=true'
            },
            'deleteIssue': {
                method: 'DELETE',
                params: {param: '@vulnerabilityID'}
            },
            'updateIssue': {
                method: 'PUT',
                params: {param: '@vulnerabilityID'}
            },
            'getreventVuls': {
                method: 'GET',
                path: '/vulnerabilities/recentVuls',
                isArray: true
            },
            'getImpactGraph': {
                method: 'POST',
                path: '/impactPath'
            }
        })
        .getInstance();
}




// WEBPACK FOOTER //
// ./modules/xray/data/dao/eventx_dao.js